import { useEffect, useState } from "react";

import { Card } from "@mui/material";
import MDBox from "components/MDBox";

import VerticalBarChart from "examples/Charts/BarCharts/VerticalBarChart";

import { generateByYearReport } from "services/reports";

// types
interface ChartData {
  labels: string[];
  datasets: {
    label: string;
    color:
      | "primary"
      | "secondary"
      | "info"
      | "success"
      | "warning"
      | "error"
      | "light"
      | "dark";
    data: number[];
  }[];
}

export default function Evolucao() {
  const [chartData, setChartData] = useState<ChartData>({} as ChartData);

  useEffect(() => {
    (async () =>
      await generateByYearReport().then((resp) => setChartData(resp.data)))();
  }, []);

  return (
    <Card
      sx={{
        display: "flex",
        py: 2,
        px: { xs: 2, sm: 4 },
        mt: 2,
        minHeight: "50vh",
      }}
    >
      <MDBox>
        <VerticalBarChart
          icon={{ color: "dark", component: "leaderboard" }}
          title="Evolução anual"
          description="Vendas anuais comparando com ano anterior."
          chart={chartData}
        />
      </MDBox>
    </Card>
  );
}
